import { gql } from '@apollo/client';

const updateCacheWithObject = (cache, newObject) => {
  cache.modify({
    fields: {
      comments: (existingComments) => {
        const newCommentsRef = cache.writeFragment({
          data: newObject,
          fragment: gql`
            fragment NewComments on CommentType {
              id
              body
              contentId
              createdAt
              moderated
              user {
                username
                avatarUrl
              }
              subCommentCount
              subComments
              opinionPositiveCount
              activeUser {
                opinionPositive
              }
              removed
              status
            }
          `,
        });

        return {
          ...existingComments,
          comments: [
            {
              __typename: 'CommentType',
              node: newCommentsRef,
            },
            ...existingComments.comments,
          ],
        };
      },
    },
  });
};

export default updateCacheWithObject;
